"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateConsent = void 0;
var constants_1 = require("../../logger/constants");
var constants_2 = require("../constants");
var lang_1 = require("../lang");
var userConsentValues = [constants_2.CONSENT_DECLINED, constants_2.CONSENT_GRANTED, constants_2.CONSENT_UNKNOWN];
function validateConsent(_a) {
    var userConsent = _a.userConsent, log = _a.log;
    userConsent = (0, lang_1.stringToUpperCase)(userConsent);
    if (userConsentValues.indexOf(userConsent) > -1)
        return userConsent;
    log.error(constants_1.ERROR_INVALID_CONFIG_PARAM, ['userConsent', userConsentValues, constants_2.CONSENT_GRANTED]);
    return constants_2.CONSENT_GRANTED;
}
exports.validateConsent = validateConsent;
